import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { api } from "../services/api";

export const fetchProjects = createAsyncThunk(
  "projects/fetch",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/projects");
      return data.projects;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to load projects");
    }
  }
);

export const createProject = createAsyncThunk(
  "projects/create",
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/projects", payload);
      return data.project;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to create project");
    }
  }
);

export const updateProject = createAsyncThunk(
  "projects/update",
  async ({ id, body }, { rejectWithValue }) => {
    try {
      const { data } = await api.put(`/projects/${id}`, body);
      return data.project;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to update project");
    }
  }
);

export const deleteProject = createAsyncThunk(
  "projects/delete",
  async (id, { rejectWithValue }) => {
    try {
      await api.delete(`/projects/${id}`);
      return id;
    } catch (err) {
      return rejectWithValue(err?.response?.data?.message || "Failed to delete project");
    }
  }
);

const slice = createSlice({
  name: "projects",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchProjects.pending, (s) => {
      s.loading = true;
      s.error = null;
    })
      .addCase(fetchProjects.fulfilled, (s, a) => {
        s.loading = false;
        s.items = a.payload;
      })
      .addCase(fetchProjects.rejected, (s, a) => {
        s.loading = false;
        s.error = a.payload;
      })
      .addCase(createProject.fulfilled, (s, a) => {
        s.items = [a.payload, ...s.items];
      })
      .addCase(updateProject.fulfilled, (s, a) => {
        s.items = s.items.map((p) => (p._id === a.payload._id ? a.payload : p));
      })
      .addCase(deleteProject.fulfilled, (s, a) => {
        s.items = s.items.filter((p) => p._id !== a.payload);
      });
  },
});

export default slice.reducer;
